<ng-template #content>
  <div class="success-modal-container" [class.in-dialog]="isRightSideContent">
    <div class="success-modal-content" [class.in-dialog]="isRightSideContent">
      <div class="success-icon-wrapper">
        <span class="material-icons success-icon">check_circle</span>
      </div>
      <h2 class="success-title">{{ params?.titlecase ? (params?.header | titlecase) : params?.header }}</h2>
      <div class="success-body">
        <p>{{ params?.body }}</p>
      </div>
      @if (errorMessage) {
        <div class="error-section">
          <tidy-error-message [text]="errorMessage" />
        </div>
      }
      <div class="success-buttons">
        @if (params?.secondButtonText) {
          <tidy-button
            [text]="params?.secondButtonText"
            [action]="boundSecondButtonAction"
            class="primary full-width" />
        }
        <tidy-button
          [text]="params?.buttonText || 'Go to Schedule'"
          [action]="boundButtonAction"
          [class]="(params?.secondButtonText && !params?.allButtonsPrimary) ? 'secondary full-width' : 'primary full-width'" />
      </div>
    </div>
  </div>
</ng-template>

@if (!isRightSideContent) {
  @if (params?.fromGettingStarted) {
    <tidy-top-nav
      [title]="''"
      [canGoBack]="true"
      [customBack]="'getting-started'" />
  }
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ng-container *ngTemplateOutlet="content" />
}
